import { useCustomer } from "autumn-js/react";
import { useEffect } from "react";
import { useLocalStorage } from "@/hooks/common/useLocalStorage";
import { notNullish } from "@/utils/genUtils";

export const useAutumnFlags = () => {
	const { data: customer, isPending } = useCustomer();
	// Only the prod app gates the Atom tab on billing; staging and local have no billing key and an open server gate.
	const isProdApp = window.location.hostname === "app.useautumn.com";

	const [flags, setFlags] = useLocalStorage("autumn.flags", {
		stripe_key: false,
		platform: false,
		vercel: false,
		revenuecat: false,
		sso: false,
		atoms: false,
	});

	useEffect(() => {
		if (!customer?.flags) return;

		const nextFlags = {
			stripe_key: notNullish(customer.flags.stripe_key),
			platform: notNullish(customer.flags.platform),
			vercel: notNullish(customer.flags.vercel),
			revenuecat: notNullish(customer.flags.revenuecat),
			sso: notNullish(customer.flags.sso),
			// `atoms` is metered (a count of Atoms), so it arrives as a balance, not a flag.
			atoms: (customer.balances?.atoms?.remaining ?? 0) > 0,
		};

		// Only update storage/state when values actually change
		if (
			flags.stripe_key !== nextFlags.stripe_key ||
			flags.platform !== nextFlags.platform ||
			flags.vercel !== nextFlags.vercel ||
			flags.revenuecat !== nextFlags.revenuecat ||
			flags.sso !== nextFlags.sso ||
			flags.atoms !== nextFlags.atoms
		) {
			setFlags(nextFlags);
		}
	}, [customer?.flags]);

	// Webhooks have been released publicly — always on.
	return {
		...flags,
		atoms: flags.atoms || !isProdApp,
		webhooks: true as const,
		/** Billing hasn't answered yet, so a false flag may still turn true. */
		isLoading: isPending,
	};
};
